<template>
  <div class="register-form">
    <div class="group">
      <template v-if="!is_japan_locale">
        <input
          id="name"
          v-model="name"
          v-validate="'required'"
          type="text"
          :class="{ error: errors.has('name'), valid: fields.name ? fields.name.valid : null }"
          name="name"
          :placeholder="$tr('vacancy.openRegistrationVideoresume.labelName')"
        />
        <label v-if="errors.has('name')" class="helper">{{ $tr('common.requiredField') }}</label>
      </template>

      <template v-else>
        <input
          id="surname"
          v-model="surname"
          v-validate="'required'"
          type="text"
          :class="{
            error: errors.has('surname'),
            valid: fields.surname ? fields.surname.valid : null
          }"
          name="surname"
          :placeholder="$tr('vacancy.openRegistrationVideoresume.labelSurname')"
        />
        <label v-if="errors.has('surname')" class="helper">{{ $tr('common.requiredField') }}</label>
      </template>
    </div>

    <div class="group">
      <template v-if="!is_japan_locale">
        <input
          id="surname"
          v-model="surname"
          v-validate="'required'"
          type="text"
          :class="{
            error: errors.has('surname'),
            valid: fields.surname ? fields.surname.valid : null
          }"
          name="surname"
          :placeholder="$tr('vacancy.openRegistrationVideoresume.labelSurname')"
        />
        <label v-if="errors.has('surname')" class="helper">{{ $tr('common.requiredField') }}</label>
      </template>

      <template v-else>
        <input
          id="name"
          v-model="name"
          v-validate="'required'"
          type="text"
          :class="{ error: errors.has('name'), valid: fields.name ? fields.name.valid : null }"
          name="name"
          :placeholder="$tr('vacancy.openRegistrationVideoresume.labelName')"
        />
        <label v-if="errors.has('name')" class="helper">{{ $tr('common.requiredField') }}</label>
      </template>
    </div>

    <div class="group">
      <input
        id="email"
        v-model="email"
        v-validate="'required|email'"
        type="email"
        :class="{
          error: errors.has('email') || (customErrors && customErrors.email),
          valid: fields.email ? fields.email.valid : null
        }"
        name="email"
        :placeholder="$tr('vacancy.openRegistrationVideoresume.labelEmail')"
        @keyup="$emit('keyup')"
      />
      <label v-if="errors.has('email') && errors.first('email')" class="helper">
        {{ errors.first('email') }}
      </label>
      <label v-if="customErrors && customErrors.email" class="helper">
        {{ customErrors.email }}
      </label>
    </div>

    <div class="group phone">
      <vphone
        v-model.lazy="phone"
        class="reg_input"
        :border="true"
        :placeholder="$tr('vacancy.openRegistrationVideoresume.placeholderPhone')"
        :class="{
          error: !phone_valid,
          valid: phone_valid,
          touched: phoneTouched,
          focus: phoneFocused
        }"
        @valid="phone_valid = $event"
      />
    </div>

    <div v-if="show_captcha" class="line line__recaptcha">
      <vue-recaptcha
        load-recaptcha-script
        :sitekey="sitekey"
        @verify="check_captcha"
        @expired="reset_captcha"
      ></vue-recaptcha>
    </div>

    <div class="line register">
      <vresume-button
        :text="$tr('vacancy.openRegistrationVideoresume.register')"
        :disabled="formSubmitted || !submitButtonEnabled || !can_register"
        :loading="loading"
        @click="saveUser"
      />

      <div
        class="videoresume-agreement"
        v-html="
          $tr('vacancy.openRegistrationVideoresume.personalAgree', {
            privacy_link: privacy_link,
            terms_link: terms_link,
            cookies_link: cookies_link
          })
        "
      ></div>
    </div>
  </div>
</template>

<script>
// import { getCountryCallingCode } from 'libphonenumber-js'
// import { STORE_PREFIX } from '../../constants.js';
// import PhoneMaskInput from '@/components/shared/PhoneMaskInput.vue';
import { mapGetters } from 'vuex';
import PhoneMaskValidator from '@/components/invites/creation/PhoneMaskValidator.js';
import VueRecaptcha from 'vue-recaptcha';

import { mergeDeep } from '@/_helpers/utils.js';

const dictionary = {
  en: {
    // This empty object need to correct work
    messages: {},
    attributes: {}
  },
  ru: {
    // This empty object need to correct work
    messages: {},
    attributes: {}
  }
};

export default {
  name: 'OpenRegistrationFormVideoresume',

  components: {
    // PhoneMaskInput,
    VueRecaptcha
  },

  props: {
    customErrors: {
      type: Object,
      default: null
    },

    companyInfo: {
      type: Object,
      default: null
    },

    locale: {
      type: String,
      default: ''
    },

    is_japan_locale: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    },

    country: {
      default: null
    },

    sitekey: {
      default: null
    },

    recaptcha_res: {
      default: null
    },

    disabled: {
      default: false
    },

    show_captcha: {
      default: false
    }
  },

  data() {
    return {
      name: '',
      surname: '',
      email: '',
      phone: '',
      phone_valid: false,
      phoneTouched: false,
      phoneFocused: false,
      phoneMask: '',
      updatedPhone: '',
      formSubmitted: false
    };
  },

  computed: {
    ...mapGetters('landing', {
      landing: 'item',
      landing_token: 'token'
    }),

    pass_captcha() {
      // чекаем капчу только если дошли до этапа чека капчи
      return this.show_captcha ? this.recaptcha_res !== null : true;
    },

    can_register() {
      // проверяем можно ли пускать авторизацию
      return this.disabled === false && this.pass_captcha;
    },

    terms_link() {
      return 'https://vcv.' + this.current_domain + '/pages/terms-of-service/';
    },

    privacy_link() {
      switch (this.locale) {
        case 'ru':
          return 'https://vcv.ru/pages/privacy-policy';
        default:
          return 'https://vcv.ai/pages/privacy-policy';
      }
    },

    cookies_link() {
      switch (this.locale) {
        case 'en':
          return 'https://vcv.ai/pages/cookies-terms';
        case 'ru':
          return 'https://vcv.ru/pages/cookies-terms-ru';
        case 'ja':
          return 'https://vcv.ai/pages/cookies-terms';
        default:
          return 'https://vcv.ai/pages/cookies-terms';
      }
    },

    current_domain() {
      if (this.locale === 'ru') {
        return 'ru';
      } else {
        return 'ai';
      }
    },

    activeModules() {
      if (!this.landing) {
        return null;
      }

      return this.landing.active_modules;
    },

    hasVideo() {
      if (!this.activeModules || !this.activeModules.length) {
        return false;
      }

      let has_video = false;

      this.activeModules.forEach(activeModule => {
        if (activeModule.id === 'videointerview') {
          has_video = true;
        }

        if (activeModule.child_modules && activeModule.child_modules.length) {
          activeModule.child_modules.forEach(childModule => {
            if (childModule.id === 'anticheating') {
              has_video = true;
            }
          });
        }
      });
      return has_video;
    },

    vacancyToken() {
      return this.companyInfo ? this.companyInfo.token : null;
    },

    submitButtonEnabled() {
      const fields = Object.keys(this.fields).map(k => this.fields[k]);

      return fields.filter(f => f.required).every(f => f.valid === true) && this.phone_valid;
    },

    companyCountry() {
      const country = this.companyInfo ? this.companyInfo.country : null;

      return country ? country.code : null;
    }
  },

  created() {
    this.formSubmitted = false;
    mergeDeep(dictionary, PhoneMaskValidator.dictionary);

    this.$validator.extend('verify_phone', PhoneMaskValidator.validator);
  },

  methods: {
    check_captcha(v) {
      this.formSubmitted = false;
      this.$emit('check_captcha', v);
    },

    reset_captcha() {
      this.formSubmitted = false;
      this.$emit('reset_captcha');
    },

    touch() {
      this.phoneTouched = true;
    },

    changeFocus(val) {
      this.phoneFocused = val;
    },

    changeValidPhone(val) {
      this.phoneValid = val;
    },

    changePhone(phone) {
      this.updatedPhone = phone;
    },

    changePhoneCountry(val) {
      this.phoneMask = val;
    },

    saveUser() {
      this.formSubmitted = true;

      const phone = this.phone.length > 6 ? this.phone : '';
      const interview = {
        vacancyToken: this.vacancyToken,
        candidate: {
          name: this.name,
          surname: this.surname,
          email: this.email,
          phone
        }
      };

      this.$emit('onSubmit', interview);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors';
@import '@/styles/variables.scss';

.register-form {
  *,
  ::v-deep * {
    // font-family: 'Euclid Circular A';
  }
}
div.reg_input.error {
  margin-top: 0 !important;
}
.margin_right {
  margin-right: 10px;
}
.accept_label {
  min-width: 20px;
  margin-right: 10px;
}
.flex_center {
  display: flex;
  align-items: flex-start;
}
.group-title {
  display: inline-block;
  vertical-align: top;
  margin-bottom: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #233346;
}

.container {
  .image {
    text-align: center;
  }

  img {
    max-width: 100%;
    max-height: 200px;
  }

  h1 {
    font-size: 24px;
    font-weight: normal;
    margin: 22px 0 34px;
  }

  .group {
    position: relative;
    margin-bottom: 0;
    min-height: 78px;

    &.phone {
      min-height: 86px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    input,
    ::v-deep .vinput .input {
      // font-family: 'Euclid Circular A';
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 24px;
      color: #8d8d8d;
      background: #ffffff;
      border: 1px solid #d1d8e0;
      box-sizing: border-box;
      border-radius: 4px;
      padding: 16px;
      height: 56px;
      min-height: 56px;
      max-height: 56px;

      &::placeholder {
        color: #c4b9d3;
      }
    }

    // TODO: Refactor this.
    // We use .touched class as an
    // alternative for :focus, because we need detect
    // focus on child element
    .phone-input {
      ~ .bar {
        position: absolute;
        bottom: 0;
      }

      &.valid ~ label.placeholder,
      &.focus ~ label.placeholder,
      &.error.touched ~ label.placeholder {
        top: 0;
        font-size: 14px;
      }

      &.touched ~ .bar:before,
      &.focus ~ .bar:before,
      &.valid ~ .bar:before {
        width: 100%;
      }

      &.error.touched {
        & ~ .bar:before {
          background: #ed6f6e;
        }

        & ~ label {
          color: #ed6f6e;
        }

        & ~ label.helper {
          display: block;
        }
      }
    }

    input[type='text'],
    input[type='email'] {
      font-size: 16px;
      margin: 0;
      display: block;
      width: 100%;

      @media (max-width: 768px) {
        font-size: 14px;
      }

      &:focus {
        outline: none;
      }

      &:focus ~ label.placeholder,
      &.valid ~ label.placeholder,
      &.error ~ label.placeholder {
        top: 0;
        font-size: 14px;
      }

      &:focus ~ .bar:before,
      &.valid ~ .bar:before {
        width: 100%;
      }

      &.error {
        & ~ .bar:before {
          background: #ed6f6e;
        }

        & ~ label {
          color: #ed6f6e;
        }

        & ~ label.helper {
          display: block;
        }
      }
    }

    input[type='text']:read-only {
      pointer-events: none;
    }

    input[type='file'] {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;

      + .actions {
        display: block;
        position: absolute;
        right: 10px;
        top: 9px;
        display: flex;
        align-items: center;

        span {
          cursor: pointer;
          text-decoration: underline;
        }

        label .icon-upload {
          margin-left: 5px;
          cursor: pointer;
          width: 24px;
          font-size: 21px;
          color: $green;
          height: 24px;
        }
      }
    }
    input.error + input[type='file'] {
      + label .icon-upload {
        color: $red-color;
      }
    }

    label.placeholder {
      margin: 0;
      color: #c4b9d3;
      font-size: 16px;
      font-weight: 300;
      position: absolute;
      pointer-events: none;
      top: 36px;
      transition: 0.2s ease all;
    }

    &.phone label.placeholder {
      left: 75px;
    }

    label.helper {
      margin: 0;
      color: #a6a6a6;
      font-size: 12px;
      font-weight: normal;
      padding-top: 1px;
    }

    .bar {
      position: relative;
      display: block;
      width: 100%;

      &:before {
        left: 0;
        content: '';
        height: 2px;
        width: 0;
        bottom: 0;
        position: absolute;
        background: $green;
        transition: 0.2s ease all;
      }
    }

    &.right-icon {
      label.placeholder {
        padding-right: 45px;
      }
    }
  }

  .group--label {
    min-height: auto;
    margin-bottom: 30px;
  }

  button.vcv-button {
    font-weight: normal;
    text-transform: uppercase;
  }

  .line {
    margin: 0;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 19px;
    color: #233346;

    & .line-right {
      margin-left: auto;
    }

    &.register {
      margin: 0 auto;
      display: flex;
      align-items: flex-end;
      flex-direction: column;

      @media (max-width: 768px) {
        margin-top: 24px;
        justify-content: flex-start;
      }

      .vcv-button {
        width: 210px;

        @media (max-width: 768px) {
          width: auto;
          max-width: 210px;
        }
      }

      .line-right {
        padding-left: 0;
        margin-left: 10px;
        font-size: 13px;
        line-height: 19px;
        color: #9faab6;

        @media (max-width: 768px) {
          margin: 15px auto;
          &:after {
            content: '';
            display: block;
            height: 20px;
          }
        }
      }
    }
  }
}

.column-checkbox {
  display: flex;
  align-items: center;
  span {
    width: calc(100% - 20px);
  }
}

.resume-wrapper {
  position: relative;
}
.margin_right {
  margin-right: 10px;
}

.videoresume-agreement {
  margin-top: 8px;
  max-width: 280px;
  // font-family: 'Euclid Circular A';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  color: #c4b9d3;

  ::v-deep a {
    font-weight: 700;
    color: #c4b9d3;

    &:hover,
    &:focus,
    &:active {
      color: #c4b9d3;
    }
  }
}
</style>
